<template>
  <div class="content">
    <div class="container-fluid">
      <b-navbar type="light" variant="light" sticky>
        <b-navbar-nav>
          <b-button pill variant="secondary" :to="urlBack()" v-if="hasBack()"><b-icon icon="caret-left" aria-hidden="true"></b-icon>Retour</b-button>
          <!-- Navbar dropdowns -->
          <b-nav-item-dropdown text="Actions" left v-if="isAdmin()">
            <b-dropdown-item @click="duplicateOperationWithConfirm('')"><b-icon icon="file-earmark-plus" variant="warning"></b-icon> Dupliquer ?</b-dropdown-item>
            <b-dropdown-item @click="deleteOperationWithConfirm('')"><b-icon icon="dash-circle" variant="danger"></b-icon> Supprimer ?</b-dropdown-item>
            <b-dropdown-item :to="sendEmailToAll()" v-if="companies.length>0"><b-icon icon="envelope" variant="success"></b-icon> Envoyer un email aux {{ companies.length }} sociétés ?</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-navbar>

      <!-- <router-link class="btn btn-secondary btn-sm float-right" :to="urlSendEmail()" v-if="isAdmin()" >Email</router-link> -->
      
      <b-tabs v-model="activeTabIndex" nav-class="mb-3" content-class="mt-2">
        <b-tab>
          <template #title>
            Opération - {{ operation.operationname || '' }}
          </template>
      <!-- Operation Card 1 -->
      <div class="row">
        <div class="col-lg-12 col-12">
          <stats-card :style="getCardStyle(operation._status)">
            
            <div slot="content">
              <img v-if="this.operation.image && this.operation.image.length" style="max-height:200px;max-width:300px" class="float-right" :src="`${this.$http.baseURL}/form/image?uid=${this.operation.image[0].name}`" />
              <h4 class="d-flex align-items-center card-title" style="padding: 4pt;">
                <status-icon :status="operation._status" css-class="icon-small"/>&nbsp;
                {{operation.code}} - {{operation.operationname}}
              </h4>
              <p class="card-category" :title="company.id">{{company.name}} 
              
                <router-link v-if="isAdmin()" :to="urlWithRedirect('/ppe_eu/home/'+account.id)"><b-icon icon="pencil-square"></b-icon> 
                {{account.name}}</router-link>
                 
                </p>
              <div class="row">
                
                  <div class="col-lg-3 col-4"><span class="font-weight-bold"><label-editable editable=true resourcekey="operation.code" text="Opération"/></span></div>
                  <div class="col-lg-3 col-8">{{operation.code}}</div>
                  <div class="col-lg-2 col-4"><span class="font-weight-bold"><label-editable editable=true resourcekey="operation.type" text="Type"/></span></div> <!-- https://bootstrap-vue.org/docs/reference/utility-classes -->
                  <div class="col-lg-4 col-8" v-if="operation.type">{{getOperationLabel(operation.type)}}</div>
              </div>
              <div class="row">
                  <div class="col-lg-3 col-4"><span class="font-weight-bold"><label-editable editable=true resourcekey="operation.description" text="Description"/></span></div>
                  <div class="col-lg-7 col-8"><span style="white-space: pre-line">{{operation.description}}</span></div>
              </div>
              <div class="row">
                <div class="col-lg-3 col-4"><span class="font-weight-bold"><label-editable editable=true resourcekey="operation.address" text="Adresse"/></span></div> 
                <div class="col-lg-9 col-8"><div>{{operation.sitename}}</div>
                <div>{{operation.address}} {{operation.zip}} {{operation.city}}</div></div>
              </div>
              <div class="row">
                <div class="col-lg-3 col-4"><span class="font-weight-bold"><label-editable editable=true resourcekey="operation.startDate" text="Début prévu"/></span></div>
                <div class="col-lg-3 col-8">{{toDate(operation.startDate)}}</div>
                <div class="col-lg-2 col-4"><span class="font-weight-bold"><label-editable editable=true resourcekey="operation.duration" text="Durée"/></span></div> 
                <div class="col-lg-4 col-8">{{operation.duration}}</div>
              </div>
            </div>
            <div slot="footer">
                  <div>
                    <i v-if="this.d3" class="fa fa-calendar-o"></i> {{toDate(operation._modified)}}
                    <router-link class="card-link" :to="urlWithRedirect('/ppe_eu/operation/'+account.id+'/'+operation.id)">
                      <label-editable editable=true resourcekey="modify" text="Modifier"/>
                      
                    </router-link>
                    
                  </div>
            </div>
          </stats-card>

        </div>
      </div>  
      <!-- Operation Card 2 -->
      <div class="row">
        <!-- D3. LAP Livret d'Accueil Prévention -->
        <div class="col-lg-6 col-12">
          <stats-card :style="getCardStyle(this.d3?this.d3._status:'draft')">
            
            <div slot="content">
              <h4 class="d-flex flex-row align-items-center card-title">
                <status-icon class="" v-if="this.d3" :status="this.d3._status" />
                <status-icon class="" v-if="!this.d3" status="draft" />
                <label-editable class="" editable=true resourcekey="d3.title" text="D3.. LAP Livret d'Accueil Prévention"/>
              </h4>
              <p class="card-category"><label-editable editable=true resourcekey="d3.subtitle" text="Analyse des dangers spécifiques liés à l'opération"/></p>
            </div>
            <div slot="footer">
              <i v-if="this.d3" class="fa fa-calendar-o"></i> {{this.d3?toDate(this.d3._modified):''}}
              <router-link v-if="this.d3" :to="urlWithRedirect('/ppe_eu/d3/'+this.d3.id+'?operationid='+ operation.id)"><label-editable editable=true resourcekey="modify" text="Modifier"/></router-link>

              <router-link v-if="!this.d3" :to="urlWithRedirect('/ppe_eu/d3/'+this.operation.id+'/'+this.company.id)"><label-editable editable=true resourcekey="create" text="Compléter"/></router-link>
            </div>
          </stats-card>
        </div>

        <div class="col-lg-6 col-12">
          <div class="card" :style="getCardStyle(operation._status!=='draft' && isCompleted()?'valid':'draft') + ';padding:10pt;'">
            <h4 class="card-title"><label-editable editable=true resourcekey="ppe_title" text="Plan de Prévention Evolutif sur l'opération"/></h4>
            <p></p>
            <p></p>
            <p></p>
            <p></p>
            <!-- https://bootstrap-vue.org/docs/icons#icons-1 -->
            <a href="#"  @click="downloadPDF" class="d-flex align-items-center card-link" v-if="operation._status!=='draft' && isCompleted()">
                    <b-icon icon="file-earmark-arrow-down" title="Téléchager au format PDF"></b-icon> 
                    <label-editable editable=true resourcekey="ppe_title.download" text="Télécharger le PPE"/></a>
                    <b-icon icon="arrow-clockwise" animation="spin" font-scale="2" v-if="pdfLoading"></b-icon>
            <div v-if="!(operation._status!=='draft' && isCompleted())">Quand vous aurez complété l'opération, vous pourrez télécharger, ici, le format PDF</div>
          </div>
        </div>
      </div>

        </b-tab>
        <b-tab>
          <template #title>
            Sociétés - {{ companies.length }}
          </template>
          <!-- Companies -->
          <div class="row">
          <div class="col-xl-12 col-md-12">
            <card class="strpied-tabled-with-hover" body-classes="">
              <template slot="header">
                <h4 class="card-title"><label-editable editable=true resourcekey="ppe_company_list.title" text="Sociétés intervenant sur ce projet / opération"/></h4>
                <p class="card-category"><label-editable editable=true resourcekey="ppe_company_list.subtitle" text="Liste des sociétés enregistrées sur cette opération / projet"/></p>
              </template>
                <b-table responsive striped hover :items="filteredCompanies" :fields="columnsCompanies" v-if="companies.length>0">
                  <template #thead-top>
                    <tr>
                      <th></th>
                      <th>
                        <b-form-select
                          size="sm"
                          :options="companyStatusOptions"
                          v-model="companyColumnFilters.status"
                        />
                      </th>
                      <th>
                        <div class="d-flex flex-column flex-md-row">
                          <b-form-input
                            size="sm"
                            type="date"
                            v-model="companyColumnFilters.validatedStart"
                            class="mb-1 mb-md-0"
                            placeholder="Du"
                          />
                          <b-form-input
                            v-if="companyColumnFilters.validatedStart"
                            size="sm"
                            type="date"
                            v-model="companyColumnFilters.validatedEnd"
                            class="ml-md-1"
                            placeholder="Au"
                          />
                        </div>
                      </th>
                      <th>
                        <b-form-input
                          size="sm"
                          v-model="companyColumnFilters.name"
                          placeholder="Filtrer"
                        />
                      </th>
                      <th>
                        <b-form-input
                          size="sm"
                          v-model="companyColumnFilters.owner"
                          placeholder="Filtrer"
                        />
                      </th>
                      <th>
                        <div class="d-flex flex-column flex-md-row">
                          <b-form-input
                            size="sm"
                            type="date"
                            v-model="companyColumnFilters.subscribedStart"
                            class="mb-1 mb-md-0"
                            placeholder="Du"
                          />
                          <b-form-input
                            v-if="companyColumnFilters.subscribedStart"
                            size="sm"
                            type="date"
                            v-model="companyColumnFilters.subscribedEnd"
                            class="ml-md-1"
                            placeholder="Au"
                          />
                        </div>
                      </th>
                      <th>
                        <b-form-input
                          size="sm"
                          v-model="companyColumnFilters.address"
                          placeholder="Filtrer"
                        />
                      </th>
                      <th>
                        <b-form-input
                          size="sm"
                          v-model="companyColumnFilters.activity"
                          placeholder="Filtrer"
                        />
                      </th>
                      <th v-if="isAdminManagerOrPartner()">
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          @click="resetCompanyFilters"
                        >
                          Réinitialiser
                        </b-button>
                      </th>
                    </tr>
                  </template>
                  <template #cell(id)="row">
                    {{ row.index + 1 }}
                  </template>
                  <template #cell(owner)="row">
                    <router-link v-if="row.item.id && (isAdminManagerOrPartner())" :to="urlWithRedirect('/ppe_ee/account/'+row.item.owner.id)">{{row.item.owner.email}}</router-link>&nbsp;
                  </template>
                  <template #cell(_status)="row">
                    <b><status-icon :status="row.item._status" /></b>
                  </template>
                  <template #cell(_subscribed)="row">
                    {{toDate(row.item._subscribed)}}
                  </template>
                  <template #cell(_validated)="row">
                    {{toDate(row.item._validated)}}
                  </template>
                  <template #cell(address)="row">
                    {{row.item.zip}} {{row.item.city}}
                  </template>
                  <template #cell(subscriptionId)="row">
                    <router-link v-if="row.item.id && (isAdminManagerOrPartner())" :to="urlWithRedirect('/ppe_ee/operation_home_ee/'+row.item.subscriptionId)">Ouvrir</router-link>&nbsp;
                    <button class="btn btn-danger btn-sm float-right" v-on:click="deleteSubscriptionWithConfirm(row.item.name, row.item.subscriptionId)" v-if="isAdmin()||isManager()" >Retirer</button>
                  </template>
              </b-table>

              <div>
                <b-button v-b-modal.modal-prevent-closing>Ajouter une société</b-button>

                <b-modal
                  id="modal-prevent-closing"
                  ref="modal"
                  title="Description de la société"
                  @show="resetModal"
                  @hidden="resetModal"
                  @ok="handleOk"
                >
                  <form ref="form" @submit.stop.prevent="handleSubmit">
                    <b-form-autocomplete
                    id="companyname-input"
                    v-model="selectedCompany"
                    :data="formattedCompanies"
                    :state="companynameState"
                    placeholder="Type to search companies"
                    @input="fetchCompanies"
                    required
                    ></b-form-autocomplete>
                    <b-form-group label="Raison sociale" label-for="companyname-input" invalid-feedback="Champ obligatoire" :state="companynameState">
                      <b-form-input id="companyname-input" v-model="companyname" :state="companynameState" required list="my-list-id"></b-form-input>
                    </b-form-group>
                    <b-form-group label="Nom du responsable" label-for="name-input" invalid-feedback="Champ obligatoire" :state="nameState">
                      <b-form-input id="name-input" v-model="name" :state="nameState" required></b-form-input>
                    </b-form-group>
                    <b-form-group label="Email" label-for="email-input" invalid-feedback="Champ obligatoire" :state="emailState">
                      <b-form-input id="email-input" v-model="email" :state="emailState" required></b-form-input>
                    </b-form-group>
                  </form>
                </b-modal>
              </div>

              
              <h5 v-if="companies.length<=0">Aucune société n'est encore inscrite</h5>
            </card>
          </div>
          </div>

        </b-tab>
        <b-tab>
          <template #title>
            Sociétés invitées - {{ invites.length }}
          </template>
          <!-- Invited Companies -->
          <div class="row">
            <div class="col-xl-12 col-md-12">
              <card class="strpied-tabled-with-hover" body-classes="">
                <template slot="header">
                  <h4 class="card-title"><label-editable editable=true resourcekey="ppe_company_list.title" text="Sociétés invitées"/></h4>
                  <p class="card-category"><label-editable editable=true resourcekey="ppe_company_list.subtitle" text="Liste des sociétés invitées sur cette opération / projet"/></p>
                </template>
                  <b-table responsive striped hover :items="filteredInvites" :fields="columnsInvites" v-if="invites.length>0">
                    <template #thead-top>
                      <tr>
                        <th></th>
                        <th>
                          <b-form-select
                            size="sm"
                            :options="inviteStatusOptions"
                            v-model="inviteColumnFilters.status"
                          />
                        </th>
                        <th>
                          <b-form-input
                            size="sm"
                            v-model="inviteColumnFilters.email"
                            placeholder="Filtrer"
                          />
                        </th>
                        <th>
                          <b-form-input
                            size="sm"
                            v-model="inviteColumnFilters.companyName"
                            placeholder="Filtrer"
                          />
                        </th>
                        <th>
                          <div class="d-flex flex-column flex-md-row">
                            <b-form-input
                              size="sm"
                              type="date"
                              v-model="inviteColumnFilters.createdStart"
                              class="mb-1 mb-md-0"
                              placeholder="Du"
                            />
                            <b-form-input
                              v-if="inviteColumnFilters.createdStart"
                              size="sm"
                              type="date"
                              v-model="inviteColumnFilters.createdEnd"
                              class="ml-md-1"
                              placeholder="Au"
                            />
                          </div>
                        </th>
                        <th>
                          <div class="d-flex flex-column flex-md-row">
                            <b-form-input
                              size="sm"
                              type="date"
                              v-model="inviteColumnFilters.modifiedStart"
                              class="mb-1 mb-md-0"
                              placeholder="Du"
                            />
                            <b-form-input
                              v-if="inviteColumnFilters.modifiedStart"
                              size="sm"
                              type="date"
                              v-model="inviteColumnFilters.modifiedEnd"
                              class="ml-md-1"
                              placeholder="Au"
                            />
                          </div>
                        </th>
                        <th>
                          <b-form-input
                            size="sm"
                            type="number"
                            min="0"
                            v-model="inviteColumnFilters.inviteCount"
                            placeholder="Filtrer"
                          />
                        </th>
                        <th>
                          <b-button
                            size="sm"
                            variant="outline-secondary"
                            @click="resetInviteFilters"
                          >
                            Réinitialiser
                          </b-button>
                        </th>
                      </tr>
                    </template>
                    <template #cell(rank)="row">
                      {{ row.index + 1 }}
                    </template>
                    <template #cell(inviteStatus)="row">
                      {{ getInviteStatusLabel(row.item.inviteStatus) }}
                    </template>
                    <template #cell(_created)="row">
                      {{toDate(row.item._created)}}
                    </template>
                    <template #cell(_modified)="row">
                      {{toDate(row.item._modified)}}
                    </template>
                    <template #cell(id)="row">
                      <button title="Renvoyer l'invitation (demande confirmation)" class="btn btn-secondary btn-sm float-right" v-on:click="resendInviteWithConfirm(row.item)" >Relancer</button>
                      <button title="Ajouter cette société à l'opération (demande confirmation)" class="btn btn-secondary btn-sm float-right" v-on:click="addWithConfirm(row.item.email, row.item.companyName, row.item.id)" >✅ Ajouter</button>
                      <button title="Supprimer cette inviation (demande confirmation)" class="btn btn-danger btn-sm float-right" v-on:click="deleteInviteWithConfirm(row.item.email, row.item.id, row.item.inviteCount)" >❌ Supprimer</button>
                    </template>
                </b-table>
                  
                  <h5 v-if="invites.length<=0">Aucune société invitée</h5>
                  <button class="btn btn-secondary btn-sm" v-on:click="invitePersonDialog('')" >Inviter une entreprise</button>
              </card>
            </div>

          </div>

        </b-tab>
      </b-tabs>

      <b-modal
        id="invite-message-preview"
        v-model="inviteMessageModalVisible"
        title="Texte du message"
        hide-footer
        @hidden="onInviteMessagePreviewHidden"
      >
        <div v-if="inviteMessageLoading" class="text-center my-4">
          <b-icon icon="arrow-clockwise" animation="spin" font-scale="1.5"></b-icon>
        </div>
        <div v-else>
          <b-form-group v-if="inviteMessageRecipientLabel" label="Destinataire">
            <div class="d-flex flex-column flex-md-row align-items-md-center justify-content-between">
              <span class="mb-2 mb-md-0">{{ inviteMessageRecipientLabel }}</span>
              <b-button
                v-if="inviteMessageMailtoHref"
                :href="inviteMessageMailtoHref"
                variant="outline-primary"
                size="sm"
                target="_blank"
                rel="noopener"
              >
                Ouvrir dans ma messagerie
              </b-button>
            </div>
          </b-form-group>
          <b-form-group label="Sujet">
            <b-form-input :value="inviteMessagePreview.subject" readonly></b-form-input>
          </b-form-group>
          <b-form-group label="Message">
            <div class="border rounded p-3" v-html="inviteMessageBody"></div>
          </b-form-group>
        </div>
      </b-modal>
    
      
    </div>
  </div>
</template>
<script>
  
  import ChartCard from '../../components/Cards/ChartCard.vue'
  import StatsCard from '../../components/Cards/StatsCard.vue'
  import StatusIcon from '../../components/StatusIcon.vue'
  import usermanager from "../../usermanager";

  import Business from 'ppe-business'
import common from '../common/pages.js'
import ppeBusiness from 'ppe-business';

  const COMPANY_FILTERS_DEFAULTS = () => ({
    status: 'all',
    validatedStart: '',
    validatedEnd: '',
    name: '',
    owner: '',
    subscribedStart: '',
    subscribedEnd: '',
    address: '',
    activity: '',
  })

  const TAB_KEYS = ['operation', 'companies', 'invites']
  const INVITE_FILTERS_DEFAULTS = () => ({
    status: 'all',
    email: '',
    companyName: '',
    createdStart: '',
    createdEnd: '',
    modifiedStart: '',
    modifiedEnd: '',
    inviteCount: '',
  })

  export default {
    components: {
      ChartCard,
      StatsCard,
      StatusIcon,
    },

    created() {
      this.syncTabFromRoute(this.$route.query.tab)
    },


    mounted() {
      this.$http.get('/eu/operation_home?id='+this.$route.params.id) // this.$router.app._route.query.id)
        .then(response => {
          console.log("/eu/operation_home:DATA", response.data)
					this.operation = response.data.operation
          this.company = response.data.company
          this.account = response.data.account
          this.b2 = response.data.b2
          this.d1 = response.data.d1
          this.d3 = response.data.d3
          this.companies = response.data.companies
          this.invites = response.data.invites
          } )
        .catch(err => {
          // Clone the error to read the status property (otherwise it can only be read once !!!!)
          let error = JSON.parse( JSON.stringify(err) )
          console.error("ERROR", JSON.stringify(error))
					swal("Erreur", JSON.stringify(err.response ? err.response.data : error.message), "error");
          //if(error.status === 401)
          //   this.$router.replace("/login?redirect="+error.config.url)
        })
    },

    data () {
      return {
        pdfLoading : false,
        activeTabIndex: 0,

        company:{},
        operation: {},
        b2: null,
        d1: null,
        d3: null,
        account:{},
        persons: [],
        companies: [],
        invites: [],
        inviteMessageModalVisible: false,
        inviteMessageLoading: false,
        inviteMessagePreview: {
          subject: '',
          html: '',
          text: '',
          recipientName: '',
          recipientEmail: '',
        },
        inviteMessageModalResolver: null,

        columnsCompanies: [
          {key:'id',label:'#'}, 
          {key:'_status',label:'Etat'}, 
          {key:'_validated',label:'Date valide', tdClass: 'text-nowrap'}, 
          {key:'name',label:'Nom'}, 
          {key:'owner',label:'Email du compte principal'}, 
          {key:'_subscribed',label:'Date inscr', tdClass: 'text-nowrap'}, 
          {key:'address', label:'Adresse'},
          {key:'activity', label:'Activité'}, 
          (usermanager.isAdminManagerOrPartner()) ? {key:"subscriptionId", label:"Action (admin)"}:''
          ],

        columnsInvites: [
          {key:'rank', label:'#'}, 
          {key:'inviteStatus',label:'Etat'}, 
          {key:'email',label:'Email'}, 
          {key:'companyName', label:'Société'},
          {key:'_created', label:'Envoyé', tdClass: 'text-nowrap'}, 
          {key:'_modified', label:'Relance', tdClass: 'text-nowrap'},
          {key:'inviteCount', label:'Envois'},
          {key:'id', label:'Action'},
          ],

          companyname: '',
          companynameState: null,

          name: '',
          nameState: null,

          email: '',
          emailState: null,

          searchQuery: '',
          matchedCompanies: [],
          formattedCompanies: [],
          selectedCompany: '',

          companyColumnFilters: COMPANY_FILTERS_DEFAULTS(),
          inviteColumnFilters: INVITE_FILTERS_DEFAULTS(),

       }
    },

    computed: {
      filteredCompanies() {
        const filters = this.companyColumnFilters
        return this.companies.filter(company => {
          const matchesStatus = filters.status === 'all' || company._status === filters.status
          const matchesValidated = this.matchesDate(company._validated, filters.validatedStart, filters.validatedEnd)
          const matchesSubscribed = this.matchesDate(company._subscribed, filters.subscribedStart, filters.subscribedEnd)
          const matchesName = this.matchesText(company.name, filters.name)
          const ownerText = company.owner ? [company.owner.email, company.owner.name].filter(Boolean).join(' ') : ''
          const matchesOwner = this.matchesText(ownerText, filters.owner)
          const addressText = [company.address, company.zip, company.city].filter(Boolean).join(' ')
          const matchesAddress = this.matchesText(addressText, filters.address)
          const matchesActivity = this.matchesText(company.activity, filters.activity)
          return matchesStatus && matchesValidated && matchesSubscribed && matchesName && matchesOwner && matchesAddress && matchesActivity
        })
      },
      companyStatusOptions() {
        const options = [{ value: 'all', text: 'Tous' }]
        const statuses = Array.from(new Set(this.companies.map(company => company._status).filter(Boolean)))
        statuses.forEach(status => options.push({ value: status, text: ppeBusiness.getStatusLabel(status) }))
        return options
      },
      filteredInvites() {
        const filters = this.inviteColumnFilters
        return this.invites.filter(invite => {
          const matchesStatus = filters.status === 'all' || invite.inviteStatus === filters.status
          const matchesEmail = this.matchesText(invite.email, filters.email)
          const matchesCompany = this.matchesText(invite.companyName, filters.companyName)
          const matchesCreated = this.matchesDate(invite._created, filters.createdStart, filters.createdEnd)
          const matchesModified = this.matchesDate(invite._modified, filters.modifiedStart, filters.modifiedEnd)
          const matchesCount = this.matchesText(invite.inviteCount, filters.inviteCount)
          return matchesStatus && matchesEmail && matchesCompany && matchesCreated && matchesModified && matchesCount
        })
      },
      inviteStatusOptions() {
        const options = [{ value: 'all', text: 'Tous' }]
        const statuses = Array.from(new Set(this.invites.map(invite => invite.inviteStatus).filter(Boolean)))
        statuses.forEach(status => options.push({ value: status, text: this.getInviteStatusLabel(status) }))
        return options
      },
      inviteMessageBody() {
        return this.inviteMessagePreview.html || this.inviteMessagePreview.text || ''
      },
      inviteMessageRecipientLabel() {
        const name = (this.inviteMessagePreview.recipientName || '').trim()
        const email = (this.inviteMessagePreview.recipientEmail || '').trim()
        if (name && email) {
          return `${name}<${email}>`
        }
        return name || email || ''
      },
      inviteMessageMailtoHref() {
        const email = (this.inviteMessagePreview.recipientEmail || '').trim()
        if (!email) {
          return ''
        }
        const subject = encodeURIComponent(this.inviteMessagePreview.subject || '')
        const plainBody = this.inviteMessagePreview.text || this.plainTextFromHtml(this.inviteMessagePreview.html || '')
        const body = encodeURIComponent(plainBody)
        const queryParts = []
        if (subject) {
          queryParts.push(`subject=${subject}`)
        }
        if (body) {
          queryParts.push(`body=${body}`)
        }
        const query = queryParts.join('&')
        return query ? `mailto:${email}?${query}` : `mailto:${email}`
      },
    },

    watch: {
      activeTabIndex(newValue) {
        this.persistTabQuery(newValue)
      },
      '$route.query.tab'(value) {
        this.syncTabFromRoute(value)
      },
      'companyColumnFilters.validatedStart'(value) {
        if (!value) {
          this.companyColumnFilters.validatedEnd = ''
        }
      },
      'companyColumnFilters.subscribedStart'(value) {
        if (!value) {
          this.companyColumnFilters.subscribedEnd = ''
        }
      },
      'inviteColumnFilters.createdStart'(value) {
        if (!value) {
          this.inviteColumnFilters.createdEnd = ''
        }
      },
      'inviteColumnFilters.modifiedStart'(value) {
        if (!value) {
          this.inviteColumnFilters.modifiedEnd = ''
        }
      },
    },

    methods:{
      ...common.methods,
      toDate(apiDate) { return Business.toDate(apiDate) },
      getOperationLabel(operationType) { return Business.getOperationLabel(operationType) },
      getInviteStatusLabel(status) {
        return status === 'sent' ? 'Envoyé' : 'Relancé'
      },
      isAdmin() { return usermanager.isAdmin()},
      isManager() { return usermanager.isManager()},

      urlSendEmail() {
        
        //return this.urlWithRedirect(`/admin/sendemail?template_id=mail_valid_eu&euid=${this.company.id}&operationid=${this.operation.id}&accountid=${this.account.id}`)
      },
      
      downloadPDF() {
        this.pdfLoading = true;
        this.$http.get('/form/operation_pdf?operationId='+this.$route.params.id, {responseType: 'arraybuffer', timeout:30000}) 
        .then(response=> {
          //console.log(response)
          let blob = new Blob([response.data], { type: 'application/pdf' })

          // Open in a new window
          //let url = window.URL.createObjectURL(blob)
          //let win = window.open(url)
 
          /*const newWindow = window.open()
          newWindow.document.title = 'My Tab Name'
          newWindow.document.write(`<iframe src="${URL.createObjectURL(blob)}" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>`)
          */

          // Download file and give it a name
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'PPE-'+this.operation.code+'.pdf'
          this.pdfLoading = false
          link.click()
        })
        .catch( (err) => {
          this.pdfLoading = false
          //console.error("ERROR 1")
          let responseError = err.response
          let blobErr = new Blob([responseError.data], { type: 'application/json' })
          //console.log(responseError)
          let fileReader = new FileReader()
          
          fileReader.onload = (e) => {
            console.error("ERROR 1")
            console.error(JSON.parse(e.target.result))
  					swal("Erreur", JSON.stringify(JSON.parse(e.target.result).error), "error");
          }
          
          fileReader.readAsText(blobErr)
          
          console.log("ERROR BLOB", blobErr)
          //let error = JSON.parse(JSON.stringify(err))
          //console.error("ERROR 2", JSON.stringify(error))        
          })
      },

      isCompleted() {
        return this.company && this.operation ; //&& this.b2 && this.d3
      },
      async deleteOperationWithConfirm() {
        var answer = await swal({
            title: 'Confirmez ?',
            text: `Vous allez supprimer l'opération ${this.operation.code}-${this.operation.operationname} \n`,
            icon: 'warning',
            
            buttons: {
                  cancel:  "Non, annuler",
                  confirm: {text:"Oui, supprimer", className:"btn btn-danger"},
            },
          })
          if(answer) {
            try {
              let response = await this.$http.get("/admin/delete_operation?operationid="+this.operation.id);
              this.$router.push(this.urlBack())
            } catch(err) {
              swal("Erreur", JSON.stringify( err.response ? err.response.data : err.message), "error");
            } 
          }
      },
      async duplicateOperationWithConfirm() {
        let societes = ''
        if( this.companies.length>0 ) {
          if( this.companies.length===1 )
            societes = "ainsi que l'entreprise extérieure inscrite sur l'opération"
          else
            societes = `ainsi que les ${this.companies.length} entreprises extérieures inscrites sur l'opération`
        }
        var answer = await swal({
            title: 'Confirmez ?',
            text: `Vous allez dupliquer l'opération ${this.operation.code}-${this.operation.operationname} ${societes}. Vous pourrez changer le code, le nom et d'autres informations de l'opération ensuite.\n`,
            icon: 'warning',
            buttons : {
                  cancel:  "Non, annuler",
                  confirm: {text:"Oui, dupliquer", className:"btn btn-warning"},
            },
          }) 
          if(answer) {
            try { 
              let response = await this.$http.get("/admin/duplicate_operation?operationid="+this.operation.id);
              //this.$router.push(this.urlBack())
              this.$router.push(this.urlWithRedirect("/ppe_eu/operation_home/" + response.data.operation.id) )
            } catch(err) {
              swal("Erreur", JSON.stringify( err.response ? err.response.data : err.message), "error");
            } 
          }
      },
      async deleteSubscriptionWithConfirm(companyname, subscriptionid) {
        var answer = await swal({
            title: 'Confirmez ?',
            text: `Vous allez retirer l'entreprise extérieure ${companyname} de l'opération ${this.operation.code}-${this.operation.operationname} \n`,
            icon: 'warning',
            
            buttons: {
                  cancel:  "Non, annuler",
                  confirm: {text:"Oui, supprimer", className:"btn btn-danger"},
            },
          })
          if(answer) {
            try {
              let response = await this.$http.get("/admin/delete_subscription?subscriptionid="+subscriptionid);
              //this.$router.push(this.$router.currentRoute)
              location.reload()
            } catch(err) {
              swal("Erreur", JSON.stringify( err.response ? err.response.data : err.message), "error");
            } 
          }
      },

      sendEmailToAll(){
        let url = `/admin/sendemail?template_id=mail_new_year_ee&all_subscriptions=true&operationid=${this.operation.id}`
        console.log(url)
        return this.urlWithRedirect(url)
      },

      async addWithConfirm(email, companyName, inviteId) {
        var answer = await swal({
            title: 'Confirmez ?',
            text:  `Vous allez ajouter la société ${companyName} envoyée à ${email} \n`,
            icon:  'success',
            buttons: {
                  cancel:  "Non, annuler",
                  confirm: {text:"Oui, ajouter", className:"btn btn-success"},
            },
          })
          if(answer) {
            try {
              let response = await this.$http.get("/eu/operation_invite_add?id="+inviteId);
              this.invites = response.data.invites
              this.companies = response.data.companies
            } catch(err) {
              swal("Erreur", JSON.stringify( err.response ? err.response.data : err.message), "error");
            } 
          }
      },

      async deleteInviteWithConfirm(email, inviteId, count) {
        var answer = await swal({
            title: 'Confirmez ?',
            text: count <= 1 ? 
                `Vous allez supprimer l'invitation envoyée à ${email} \n`:
                `Vous allez supprimer les invitations envoyées à ${email} \n`,
            icon: 'warning',
            
            buttons: {
                  cancel:  "Non, annuler",
                  confirm: {text:"Oui, supprimer", className:"btn btn-danger"},
            },
          })
          if(answer) {
            try {
              let response = await this.$http.get("/eu/operation_invite_delete?id="+inviteId);
              this.invites = response.data.invites
            } catch(err) {
              swal("Erreur", JSON.stringify( err.response ? err.response.data : err.message), "error");
            } 
          }
      },



      async invitePersonDialog() {
        var companyName;
        var email = await swal({
            title:"Inviter une entreprise à rejoindre l'opération " + this.operation.code,
            text: "Entrez l'email de la société ?",
            content: "input",
            focusConfirm: false,
            buttons: {
                    cancel: "Annuler",
                    confirm: "Continuer"
                }
            });
          if(email) {
            let defaultName = email.split("@")[1].toUpperCase()
            defaultName = defaultName.split('.')[0]
            companyName = await swal({
            title:"Inviter une entreprise à rejoindre l'opération " + this.operation.code,
            text: "Entrez le nom de la société ?",
            
            content: {
              element:"input",
              attributes: {
                defaultValue: defaultName,
              },
            },
            focusConfirm: false,
            buttons: {
                    cancel: "Annuler",
                    confirm: "Envoyer un email"
                }
            }) || defaultName;
          }
          console.log("email", email)
          console.log("companyName", companyName)

            
            if(email && companyName) {
              await this.sendInvite(email, companyName)
            }
      },

      async resendInviteWithConfirm(invite) {
        const { email, name, companyName } = this.resolveInviteTarget(invite)
        if (!email) {
          swal("Erreur", "Impossible d'identifier l'email de l'invitation.", "error");
          return
        }
        const recipientLabel = name ? `${name} (${email})` : email
        let keepPrompt = true
        while (keepPrompt) {
          const action = await swal({
            title: 'Confirmez ?',
            text: `Vous allez renvoyer une invitation à ${recipientLabel} \n`,
            icon: 'info',
            buttons: {
              cancel: {
                text: 'Non, annuler',
                value: null,
                visible: true,
                className: 'btn btn-secondary',
              },
              preview: {
                text: 'Texte du message',
                value: 'preview',
                visible: true,
                className: 'btn btn-outline-secondary',
              },
              resend: {
                text: 'Oui, renvoyer',
                value: 'resend',
                visible: true,
                className: 'btn btn-info',
              },
            },
          })

          if (action === 'preview') {
            await this.openInviteMessagePreview({ email, name: name || companyName, companyName }, { waitForClose: true })
          }

          if (action === 'resend') {
            await this.sendInvite(email, companyName || '')
          }

          keepPrompt = false
        }
      },

      previewInviteEmail() {
        if (this.account && this.account.email) {
          return this.account.email
        }
        if (this.company && this.company.email) {
          return this.company.email
        }
        return 'invite@example.com'
      },

      async openInviteMessagePreview(target, options = {}) {
        if(!this.operation || !this.operation.id) {
          return
        }

        const waitForClose = options.waitForClose === true
        let closePromise = null
        if (waitForClose) {
          closePromise = new Promise((resolve) => {
            this.inviteMessageModalResolver = resolve
          })
        }

        const { email: emailTarget, name: nameTarget, companyName } = this.resolveInviteTarget(target)
        this.inviteMessageModalVisible = true
        this.inviteMessageLoading = true
        this.inviteMessagePreview.subject = ''
        this.inviteMessagePreview.html = ''
        this.inviteMessagePreview.text = ''
        this.inviteMessagePreview.recipientEmail = emailTarget
        this.inviteMessagePreview.recipientName = nameTarget || companyName || this.deriveDisplayNameFromEmail(emailTarget)
        try {
            const response = await this.$http.post("/eu/operation_invite", 
              { code:this.operation.code,
                operationid:this.operation.id,
                to:emailTarget,
                company:companyName || (this.company && this.company.name ? this.company.name : ''),
                accountName:this.account && this.account.name ? this.account.name : '',
                accountCompany:this.company && this.company.name ? this.company.name : '',
                preview:true,
              });

            this.inviteMessagePreview.subject = response.data.subject || ''
            this.inviteMessagePreview.html = response.data.html || ''
            this.inviteMessagePreview.text = response.data.text || ''
        } catch(err) {
            this.inviteMessageModalVisible = false
            swal("Erreur", JSON.stringify( err.response ? err.response.data : err.message), "error");
            if (waitForClose && this.inviteMessageModalResolver) {
              this.inviteMessageModalResolver()
              this.inviteMessageModalResolver = null
            }
        } finally {
            this.inviteMessageLoading = false
        }

        if (waitForClose && closePromise) {
          return await closePromise
        }
      },

      onInviteMessagePreviewHidden() {
        if (this.inviteMessageModalResolver) {
          this.inviteMessageModalResolver()
          this.inviteMessageModalResolver = null
        }
      },

      resolveInviteTarget(target) {
        if (typeof target === 'string') {
          return {
            email: target,
            name: this.deriveDisplayNameFromEmail(target),
            companyName: ''
          }
        }
        if (target && typeof target === 'object') {
          const email = target.email || ''
          const name = target.name || target.recipientName || ''
          const companyName = target.companyName || ''
          return {
            email: email || this.previewInviteEmail(),
            name: name || this.deriveDisplayNameFromEmail(email),
            companyName,
          }
        }
        return {
          email: this.previewInviteEmail(),
          name: (this.company && this.company.name) || (this.account && this.account.name) || '',
          companyName: this.company && this.company.name ? this.company.name : '',
        }
      },

      deriveDisplayNameFromEmail(email) {
        if (!email) {
          return ''
        }
        const raw = email.split('@')[0]
        const words = raw.split(/[.\-_]+/).filter(Boolean)
        if (!words.length) {
          return raw
        }
        return words
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      },

      plainTextFromHtml(html) {
        if (!html) {
          return ''
        }
        return html
          .replace(/<br\s*\/?>/gi, '\n')
          .replace(/<\/p>/gi, '\n\n')
          .replace(/<[^>]*>/g, '')
          .replace(/&nbsp;/gi, ' ')
          .replace(/&amp;/gi, '&')
          .replace(/&lt;/gi, '<')
          .replace(/&gt;/gi, '>')
          .trim()
      },

     async sendInvite(email, companyName) {
        try {
            let response = await this.$http.post("/eu/operation_invite", 
              { code:this.operation.code, operationid:this.operation.id, 
                to:email, company:companyName, 
                accountName:this.account.name, 
                accountCompany:this.company.name
              });

            swal({
              title: "Email envoyé !",
              text: `A: ${email} de la société ${companyName}`,
              icon: "success"
            });

            this.invites = response.data.invites

          } catch(err) {
            swal("Erreur", JSON.stringify( err.response ? err.response.data : err.message), "error");
          } 
      },

      checkFormValidity() {
        const valid = this.$refs.form.checkValidity()
        console.log("checkFormValidity", valid)
        this.companynameState = valid
        this.nameState = valid
        this.emailState = valid
        return valid
      },
      resetModal() {
        this.companyname = ''
        this.companynameState = null
        this.name = ''
        this.nameState = null
        this.email = ''
        this.emailState = null
      },
      handleOk(bvModalEvent) {
        // Prevent modal from closing
        bvModalEvent.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      async handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return
        }
        // Push the name to submitted names
        //this.submittedNames.push(this.name)
        console.log(this.companyname, this.name, this.email)
        try {
              let response = await this.$http.post("/eu/operation_company_add", {
                companyname:this.companyname, 
                name:this.name, 
                email:this.email,
                operationid:this.operation.id,
              });
              this.companies = response.data.companies
        } catch(err) {
              swal("Erreur", JSON.stringify( err.response ? err.response.data : err.message), "error");
        } 
        // Hide the modal manually
        this.$nextTick(() => {
          this.$bvModal.hide('modal-prevent-closing')
        })
      },


      async fetchCompanies(query) {
        if (query.length > 1) {
          let response = await this.$http.get(`/user/companies?companyname=${encodeURIComponent(query)}`);
          this.matchedCompanies = response.data;
          this.formatCompanies();
        } else {
          this.matchedCompanies = [];
          this.formattedCompanies = [];
        }
      },
      formatCompanies() {
        this.formattedCompanies = this.matchedCompanies.map(company => {
          return {
            display: `${company.name} - ${company.id}`,
            value: company.id,
          };
        });
      },
      matchesText(value, filterValue) {
        if (!filterValue) {
          return true
        }
        return (value || '').toString().toLowerCase().includes(filterValue.toLowerCase())
      },
      matchesDate(value, start, end) {
        if (!start && !end) {
          return true
        }
        if (!value) {
          return false
        }
        const currentDate = new Date(value)
        if (Number.isNaN(currentDate.getTime())) {
          return false
        }
        if (start) {
          const startDate = new Date(start)
          startDate.setHours(0, 0, 0, 0)
          if (currentDate < startDate) {
            return false
          }
        }
        if (end) {
          const endDate = new Date(end)
          endDate.setHours(23, 59, 59, 999)
          if (currentDate > endDate) {
            return false
          }
        }
        return true
      },
      resetCompanyFilters() {
        Object.assign(this.companyColumnFilters, COMPANY_FILTERS_DEFAULTS())
      },
      resetInviteFilters() {
        Object.assign(this.inviteColumnFilters, INVITE_FILTERS_DEFAULTS())
      },

      // Keep the selected tab in sync with the ?tab= query parameter
      syncTabFromRoute(tabKey) {
        const normalized = typeof tabKey === 'string' ? tabKey : ''
        const index = TAB_KEYS.indexOf(normalized)
        const nextIndex = index >= 0 ? index : 0
        if (this.activeTabIndex !== nextIndex) {
          this.activeTabIndex = nextIndex
        } else if (this.$route.query.tab !== TAB_KEYS[nextIndex]) {
          this.persistTabQuery(nextIndex)
        }
      },
      persistTabQuery(tabIndex) {
        const tabKey = TAB_KEYS[tabIndex] || TAB_KEYS[0]
        if (this.$route.query.tab === tabKey) {
          return
        }
        const newQuery = { ...this.$route.query, tab: tabKey }
        if (!this.$router || !this.$router.replace) {
          return
        }
        const replaceResult = this.$router.replace({ query: newQuery })
        if (replaceResult && typeof replaceResult.catch === 'function') {
          replaceResult.catch(() => {})
        }
      },


  },

}
</script>
<style>

</style>
